import React from 'react'

const projects = [
  {
    title: 'Dutamas Private School.',
    location: 'Kuala Lumpur.'
  },
  {
    title: 'Kolej Tentera Udara.',
    location: 'Alor Star, Kedah.'
  },
  {
    title: 'Nexus International School.',
    location: 'Precinct 15, Putrajaya.'
  },
  { title: 'Sekolah Antarabangsa.', location: 'Kajang, Selangor.' },
  {
    title: 'Sierramas International School.',
    location: 'Sungai Buloh, Selangor.'
  },
  {
    title: 'Tropicana International School.',
    location: 'Petaling Jaya, Selangor.'
  }
]

const SectorEducation = () => {
  return (
    <div className="modal-project-sector">
      <div className="feature-card-modal-content">
        <h2 className="typo-modal-tile-headline modal-headline headline">Education Sector</h2>
        <h4 className="typo-modal-project-sector-subhead">School</h4>
        <div className="modal-content-article">
          {projects.map((project, index) => (
            <div className="article-content" key={index}>
              <h5 className="typo-feature-card-modal-copy feature-card-modal-copy-highlight">
                {project.title}
              </h5>
              <p className="feature-card-modal-copy typo-feature-card-modal-copy">
                {project.location}
              </p>
            </div>
          ))}
        </div>
        <h6 className="typo-modal-noted">*More projects are being update soon.</h6>
      </div>
    </div>
  )
}

export default SectorEducation
